module.exports = __webpack_public_path__ + "static/NotoSansThai-Regular.subset-9369e7c0d4f5323fe80c1b77fcf15fc4.otf";